import React, { useState, useEffect, createContext, lazy } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation,
} from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zh_cn from 'antd/locale/zh_CN'
import zh_hk from 'antd/locale/zh_HK'
import eng from 'antd/locale/en_US'
import es_es from 'antd/locale/es_ES'
import ja_jp from 'antd/locale/ja_JP'
import ko_kr from 'antd/locale/ko_KR'
import de_de from 'antd/locale/de_DE'
import fr_fr from 'antd/locale/fr_FR'
import ms_my from 'antd/locale/ms_MY'
import id_id from 'antd/locale/id_ID'
import { IntlProvider } from 'react-intl'
import zh_CN from './static/locale/zh-CN'
import en_US from './static/locale/en-US'
import es_ES from './static/locale/es-ES'
import ja_JP from './static/locale/ja-JP'
import ko_KR from './static/locale/ko-KR'
import de_DE from './static/locale/de_DE'
import fr_FR from './static/locale/fr-FR'
import ms_MY from './static/locale/ms-MY'
import id_ID from './static/locale/id-ID'
import yue_Hant_HK from './static/locale/yue-Hant-HK'
import yue_Hans_CN from './static/locale/yue-Hans-CN'
import {
  getLocaleFromLanguage,
  getPreferredLanguageFromBrowser,
} from './utils/language'
import './App.css'

import { NavigatePage } from './main/NavigatePage'

const Interview = lazy(() => import('./main/v2/interview'))
const Delete = lazy(() => import('./main/delete'))
const Finish = lazy(() => import('./main/finish'))
const Not = lazy(() => import('./main/not'))
const CannotInterview = lazy(() => import('./main/cannotInterview'))
const Share = lazy(() => import('./main/share'))
const RespondentTranscriptPage = lazy(() =>
  import('./main/v2/respondentTranscriptPage')
)
const MbtiPage = lazy(() => import('./main/v2/mbti_page'))
export const myContext = createContext({
  locale: '',
  languageChange: () => {},
  // accessId,
})

function App() {
  const location = useLocation()
  // 首屏直接使用浏览器偏好语言；访谈信息加载后再由 languageChange 校准。
  const [locale, setLocale] = useState(() =>
    getLocaleFromLanguage(getPreferredLanguageFromBrowser())
  )
  // const [access_Id, setAccess_Id] = useState('')

  // useEffect(() => {
  // let lang = ''
  // if (localStorage.getItem('accessId')) {
  //   lang = localStorage.getItem('accessId')
  // } else {
  // const pathSearch = location.search
  // console.log(pathSearch)
  // }
  // setAccess_Id(lang)
  // }, [])

  // useEffect(() => {
  //   let lang = 'en'
  //   if (localStorage.getItem('locale')) {
  //     lang = localStorage.getItem('locale')
  //   } else {
  //     lang = (navigator.language || navigator.userLanguage).substr(0, 2) //常规浏览器语言和IE浏览器
  //     localStorage.setItem('locale', lang)
  //   }
  //   setLocale('en')
  //   // if (lang === 'zh') {
  //   //   setLocale('zh')
  //   // } else if (lang === 'en') {
  //   //   setLocale('en')
  //   // } else if (lang === 'ja') {
  //   //   setLocale('ja')
  //   // } else if (lang === 'es') {
  //   //   setLocale('es')
  //   // } else {
  //   //   setLocale('en')
  //   // }
  // }, [locale])

  const languageChange = (lang) => {
    console.log(lang)
    const locale = getLocaleFromLanguage(lang)
    console.log(locale)
    setLocale(locale)
    localStorage.setItem('locale', locale)
  }

  const contextVal = {
    locale,
    languageChange,
    // accessId
  }

  // let messages = {}
  //   messages['en'] = en_US
  //   messages['zh'] = zh_CN

  const messages = {
    en: en_US,
    zh: zh_CN,
    es: es_ES,
    ja: ja_JP,
    ko: ko_KR,
    de: de_DE,
    fr: fr_FR,
    'ms-MY': ms_MY,
    'id-ID': id_ID,
    'yue-Hant-HK': yue_Hant_HK,
    'yue-Hans-CN': yue_Hans_CN,
  }

  return (
    <IntlProvider
      // locale={locale === 'zh' ? 'zh' : 'en'}
      locale={messages[locale] ? locale : 'en'}
      messages={messages[locale] || en_US}
    >
      <ConfigProvider
        locale={
          locale === 'yue-Hant-HK'
            ? zh_hk
            : locale === 'yue-Hans-CN'
            ? zh_cn
            : locale === 'zh'
            ? zh_cn
            : locale === 'ja'
            ? ja_jp
            : locale === 'es'
            ? es_es
            : locale === 'ko'
            ? ko_kr
            : locale === 'de'
            ? de_de
            : locale === 'fr'
            ? fr_fr
            : locale === 'ms-MY'
            ? ms_my
            : locale === 'id-ID'
            ? id_id
            : eng
        }
      >
        <myContext.Provider value={contextVal}>
          <Routes>
            <Route path="/interview2/:accessId" element={<NavigatePage />} />
            <Route
              path="/interview2/:accessId/:sessionId/interview"
              element={<Interview />}
            />

            <Route path="/interview2/delete" element={<Delete />} />
            <Route path="/interview2/finish" element={<Finish />} />
            <Route
              path="/interview2/cannotInterview"
              element={<CannotInterview />}
            />
            <Route path="/interview2/not" element={<Not />} />
            <Route path="/interview2/share" element={<Share />} />
            <Route
              path="/interview2/respondentTranscriptPage"
              element={<RespondentTranscriptPage />}
            />
            <Route path="/interview2/mbti" element={<MbtiPage />} />
          </Routes>
        </myContext.Provider>
      </ConfigProvider>
    </IntlProvider>
  )
}

export default App
